import styled from 'styled-components'

export const Items = styled.div`
  p {
    margin: 7px 0px 10px 0px;
    font-size: 15px;
    font-weight: bold;
    color: #000;
  }
`